import { alpha } from "@mui/material/styles";

/** White card look shared by every premium tooltip in the summary grid. */
export const PREMIUM_TOOLTIP_SX = {
  backgroundColor: "#fff",
  color: alpha("#000", 0.87),
  border: "1px solid var(--ag-border-color, #babfc7)",
  borderRadius: "4px",
  padding: "3px 8px",
  fontSize: "0.8125rem",
  fontWeight: 500,
  whiteSpace: "pre",
} as const;
